import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Card} from 'ktm-ui';

interface IdsLimit {
    Id:string;
    Policy_Id:string;
    CreditCalcMethod:string;
};

export default KTMScreen({name:"planadmin.ben-limit.change-credit-calc"}, class extends React.Component<{limit_id:string, policy_id: string, benefit_cat_name: string}> {

    data:{
        dsLimit:IdsLimit;
    }

    // Store original data for comparison
    originalData: IdsLimit | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsLimit";
        await KTMApi.start(screen,{
            "@limit_id":this.props.limit_id,
        });
        screen.title = "Edit Credit Calculation";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.details)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Change credit calculation method"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Submit" style="primary"/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Display required field={field("CreditCalcMethod")}/>
            </Card>
        );
    }

    getChangedFields(originalData, updatedData) {
      if (!originalData) return {};

      const changes = {};
      for (const key in updatedData) {
        if (updatedData[key] !== originalData[key]) {
          changes[key] = {
            oldValue:
              originalData[key] !== undefined ? originalData[key] : "N/A",
            newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
          };
        }
      }
      return changes;
    }
    
    async submit({screen}:ActionEvent){
        // Track changes
      const changes = this.getChangedFields(
          this.originalData,
          this.data.dsLimit
      );

      const logDetails = Object.entries(changes)
          .map(([key, value]) => {
          const change = value as { oldValue: any; newValue: any };
          return `${key}: ${change.oldValue} → ${change.newValue}`;
          })
          .join(" | ");

      const policyLogs = {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
          Note: this.props.benefit_cat_name + " " +  logDetails,
          Action: "Policy Update Credit Calculation Method",
          PolicyId: this.props.policy_id,
          }),
      };
        await KTMApi.action(screen,"submit",{
            "@dsLimit.CreditCalcMethod":this.data.dsLimit.CreditCalcMethod,
            "@limit_id":this.props.limit_id,
        }).then(() => {
        fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
      });
        screen.recordChanged("updated",this.props.limit_id);
        screen.close({"continue":true});
    }

});
